(function () {
    'use strict';

    angular
        .module('app')
        .factory('emailservice', emailservice);

    emailservice.$inject = ['$http', '$q'];

    function emailservice($http, $q) {
        var service = {
            getUsers: getUsers,
            users: []
        };

        function getUsers() {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/Account/UserInfo/EmailList/').then(function (response) {
                service.users = response.data;
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }


        return service;

        function getData() { }
    }
})();